import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function getOrdersByItemNumber(requestData) {
  const apiPath = `v1/getOrdersByItemNumber?pageNo=${requestData?.page}&pageSize=${requestData?.rowsPerPage}&item=${requestData?.itemNumber}&sortDirection=${requestData?.sortDirection}&sortProperty=${requestData?.sortProperty}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.shippingInstance().get(apiPath)
}
